export default {
  isLoading: false,
  isOpenModalEliminar: false,
  isOpenModalEditar: false,
  isOpenModalDesactivar: false,
  cupo: {},
  isNewCupo: false,
  listaCupos: [],
  listaCuposFiltrados: [],
  filtrosCupos: null,

};
